import './App.css';
import Home from './components/Home';
import About from './components/About';
import Formations from './components/Formations';
import UneFormation from './components/UneFormation';
import CGV from './components/rgpd/CGV';
import PolitiqueConfidentialite from './components/rgpd/PolitiqueConfidentialite';
import MentionsLegales from './components/rgpd/MentionsLegales';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Mainmenu from './components/Mainmenu';
import Maintenance from './components/Maintenance';
import Page404 from './components/404';
import PolitiqueCookie from './components/rgpd/PolitiqueCookie';
import './components/Pages.css';
import ScrollToTop from "./api/ScrollToTop";

import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

import CookieConsent from "react-cookie-consent";
import { Container } from 'react-bootstrap';

function App() {

  const maintenanceMode = false; // true = mode maintenance activé

  if (maintenanceMode) {
    return <Maintenance />;
  }

  return (
    <Router>
      {/* Composants visibles sur toutes les pages */}
      <Mainmenu />

      <ScrollToTop />

      {/* Routes */}
      <div id="main-content" tabIndex={-1}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/formations" element={<Formations />} />
        <Route path="/formation" element={<UneFormation />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-cookies" element={<PolitiqueCookie />} />

        <Route path="*" element={<Page404 />} />
      </Routes>
      </div>

      {/* Composant visible sur toutes les pages */}
      <Footer />
      <CookieConsent
        location="bottom"
        buttonText="Accepter"
        declineButtonText="Refuser"
        enableDeclineButton
        cookieName="mySiteCookieConsent"
        containerClasses="site-cookie-banner"
        style={{ background: "#142c49", alignItems: "center" }}
        buttonStyle={{ background: "#f5d95b", color: "#172b46", fontSize: "12px" }}
        declineButtonStyle={{ background: "#fff", color: "#172b46", fontSize: "12px" }}
        expires={150}
      >
        <Container>
          Ce site utilise des cookies pour améliorer l’expérience utilisateur.{" "}
          <a href="/politique-cookies" style={{ color: "#FFD700" }}>
            En savoir plus
          </a>
        </Container>
      </CookieConsent>
    </Router>
  );
}

export default App;
